module.exports = __webpack_public_path__ + "static/media/coursel_asset_3.9cf1abbf.jpg";